import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import * as h2Api from '../h2Api'
import * as fileManagementWizardActions from '../actions/fileManagementWizard'

const initialState = {
  isPopupOpened: false,
  uploadProgress: {
    active: false,
    pctComplete: 5,
    selected: ''
  },
  dateSort: false,
  files: [],
  tags: [],
  quota: {},
  meta: {},
  profileInfo: {},
  profileType: ''
}
const initialTagForm = {
  fileId: null,
  tags: []
}
const data = (state = initialState, action) => {
  switch (action.type) {
    case fileManagementWizardActions.FILE_WIZARD_OPEN_CLOSE:
      const cleanState = {
        ...initialState
      }

      if (action.isOpened) {
        return {
          ...state,
          isPopupOpened: true,
          uploadProgress: {
            active: false,
            selected: '',
            pctComplete: 5
          },
          fullScreen: action.fullScreen,
          profileInfo: action.profileInfo,
          profileType: action.profileType
        }
      }

      return { ...state, isPopupOpened: false }

    case fileManagementWizardActions.FILE_WIZARD_RENAME:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const rslt = action.restCall.result

        return {
          ...state,
          files: [...state.files.filter(f => f.id != rslt.id), rslt]
        }
      }

      return state

    case fileManagementWizardActions.FILE_WIZARD_FILE_DELETE:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          files: state.files.filter(f => f.id != action.fileId)
        }
      }

      return state

    case fileManagementWizardActions.FILE_WIZARD_DATE_SORT:
      return {
        ...state,
        dateSort: true
      }

    case fileManagementWizardActions.FILE_WIZARD_FILE_UPLOAD_START:
      return {
        ...state,
        uploadProgress: {
          ...state.uploadProgress,
          active: true
        }
      }

    case fileManagementWizardActions.FILE_WIZARD_FILE_UPLOAD:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const fileId = []
        const rootObj = Array.isArray(action.restCall.result)
          ? action.restCall.result
          : action.restCall.result.files

        if (rootObj.length > 0) {
          fileId.push(rootObj[0])
        }

        return {
          ...state,
          files: state.files.concat(rootObj),
          uploadProgress: {
            ...state.uploadProgress,
            active: false
          }
        }
      }

      if (action.restCall.status === h2Api.REST_CALL_STATUS.ERROR) {
        return {
          ...state,
          uploadProgress: {
            ...state.uploadProgress,
            active: false
          }
        }
      }

      if (action.restCall.status === h2Api.REST_CALL_STATUS.UPLOADING) {
        return {
          ...state,
          uploadProgress: {
            ...state.uploadProgress,
            pctComplete: action.restCall.complete
          }
        }
      }

      return state

    case fileManagementWizardActions.FILE_WIZARD_TAG_FILE:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const f = state.files.find(f => f.id === action.fileId)

        console.log('F', f)
        const f2 = {
          ...f,
          tags: [...f.tags, action.newTag ? action.restCall.result.newTag : action.tag]
        }

        console.log('F2', f2)

        return {
          ...state,
          tags: action.newTag
            ? [...state.tags, action.restCall.result.newTag]
            : state.tags,
          files: [...state.files.filter(f => f.id != action.fileId), f2]
        }
      }

      return state

    case fileManagementWizardActions.FILE_WIZARD_TAG_FILE_DELETE:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        console.log(state.files, action.fileId, action.tagId)
        const rest = state.files.filter(f => f.id !== action.fileId)
        const mod = state.files.find(f => f.id === action.fileId)
        const f3 = {
          ...mod,
          tags: mod.tags.filter(t => t.id !== action.tagId)
        }

        console.log(rest, f3)

        return {
          ...state,
          files: [...rest, f3]
        }
      }

      return state

    case fileManagementWizardActions.FILE_WIZARD_LIST_TAGS:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          tags: action.restCall.result
        }
      }

      return state

    case fileManagementWizardActions.FILE_WIZARD_LIST_FILES:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return Array.isArray(action.restCall.result)
          ? {
              ...state,
              files: action.restCall.result,
              quota: {},
              meta: {}
            }
          : {
              ...state,
              files: action.restCall.result.files,
              quota: action.restCall.result.quota,
              meta: action.restCall.result.meta
            }
      }

      return state

    default:
      return state
  }
}

export default combineReducers({
  data,
  fileTagFormRequest: h2Api.restReducer(
    fileManagementWizardActions.FILE_WIZARD_UPDATE_TAG
  ),
  tags: modelReducer('fileManagement.tags.form', initialTagForm),
  forms: formReducer('fileManagement.tags', {
    tags: initialTagForm
  })
})
